import { HttpRequestAxios } from "../../axios"


export async function POST_UPLOAD(data: any) {
    return HttpRequestAxios({ url: '/upload', data: data })
}